import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { Button, Flex, Modal } from "antd"
import { extendWidgetCart, releaseWidgetCartHolds } from "store/experiences"
import useCartHold from "./useCartHold"
import formatCountdown from "./formatCountdown"
import styles from "./CartHold.module.css"

// "Still shopping?" in the reservation's last minute, on any widget screen, with the time left.
//  - "Yes, give me 5 more minutes" (once per reservation) extends it and the popup closes.
//  - "Release my reservation" frees the places at once; the items stay in the cart.
//  - Closing it (X, Esc, outside) asks for nothing: the time keeps running.
// After the extension, the last minute shows a final warning with no extension. At 0:00 it closes on
// its own; the API stopped holding the places then, so nothing is called. No design yet.
const StillShoppingModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { shouldAsk, expiresAt, remainingMs, extensionsLeft } = useCartHold()
  const [dismissedFor, setDismissedFor] = useState(null)
  const [pendingAction, setPendingAction] = useState(null)
  const isOpen = shouldAsk && dismissedFor !== expiresAt
  const canExtend = extensionsLeft > 0
  const time = formatCountdown(remainingMs)
  const close = () => setDismissedFor(expiresAt)

  const run = (action, thunk) => async () => {
    setPendingAction(action)
    await dispatch(thunk())
    setPendingAction(null)
    // Still showing only if the API changed nothing.
    close()
  }

  return (
    <Modal
      open={isOpen}
      onCancel={close}
      footer={null}
      centered
      width={472}
      title={<span className={styles.modalTitle}>{t(canExtend ? "booking_widget.hold.ask_title" : "booking_widget.hold.final_title")}</span>}
    >
      <Flex vertical gap={24}>
        <span className={styles.modalText} role="timer">
          {t(canExtend ? "booking_widget.hold.ask_text" : "booking_widget.hold.final_text", { time })}
        </span>
        <Flex gap={12} wrap="wrap">
          <Button shape="round" size="large" color="primary" variant="outlined" loading={pendingAction === "release"} disabled={!!pendingAction} onClick={run("release", releaseWidgetCartHolds)}>
            {t("booking_widget.hold.release")}
          </Button>
          {canExtend ? (
            <Button shape="round" size="large" type="primary" loading={pendingAction === "extend"} disabled={!!pendingAction} onClick={run("extend", extendWidgetCart)}>
              {t("booking_widget.hold.ask_extend")}
            </Button>
          ) : (
            <Button shape="round" size="large" type="primary" onClick={close}>
              {t("booking_widget.hold.final_continue")}
            </Button>
          )}
        </Flex>
      </Flex>
    </Modal>
  )
}

export default StillShoppingModal
